import catalogPlugin, {
  CatalogIndexPage,
} from '@backstage/plugin-catalog/alpha';
import {
  coreExtensionData,
  createFrontendModule,
} from '@backstage/frontend-plugin-api';
import { catalogColumnsFunc } from './catalogColumns';

// The alpha `page:catalog` extension never forwards a `columns` prop, and
// catalog-react ships no columns blueprint, so the Users table's sortable
// "Date Started" column has to come from an override. Only the leaf element is
// replaced — path, routeRef, title, icon and the PageLayout stay upstream's.
//
// Params must go through `originalFactory({ params })`; passing a sibling
// `params:` key alongside `factory` throws at wiring time.
//
// Not carried over: upstream also merges the `exportConfig` input into
// `exportSettings`. We set neither, so it's a no-op today — but enabling
// catalog export later means copying that merge in here.
const catalogPageWithColumns = catalogPlugin
  .getExtension('page:catalog')
  .override({
    factory(originalFactory, { inputs, config }) {
      const filters = inputs.filters.map(f =>
        f.get(coreExtensionData.reactElement),
      );
      return originalFactory({
        params: {
          loader: async () => (
            <CatalogIndexPage
              columns={catalogColumnsFunc}
              filters={<>{filters}</>}
              pagination={config.pagination}
            />
          ),
        },
      });
    },
  });

export const catalogModule = createFrontendModule({
  pluginId: 'catalog',
  extensions: [catalogPageWithColumns],
});
